module.exports = __webpack_public_path__ + "img/store-order.86ef34e5.svg";